import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

const createKey = () => ['massActionsRequestMasters'];

const fetch = () =>
  request.get(
    `Request/workers`,
    {},
    `Произошла ошибка при загрузке мастеров`,
    'Error'
  );

const useFetch = (options) => useQuery(createKey(), fetch, options);

const queryData = { createKey, useFetch };

export default queryData;
